// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".warning-modal__edit-button[data-v-5cd4c200] {\n  margin-right: 15px;\n}\n.button-bar[data-v-5cd4c200] {\n  margin-top: 40px;\n}\n.warning-modal-field-list[data-v-5cd4c200] {\n  max-height: 400px;\n  overflow: auto;\n}\n.sub-list[data-v-5cd4c200] {\n  list-style: none;\n}\nul[data-v-5cd4c200] {\n  margin-left: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
